import { useSWR } from '@tiger/swr';
import type { PlaidBankCardItem } from 'components/vendor/plaid';
import security from 'stores/security';
import API from 'utils/API';

/**
 * ACH 可用入金银行卡列表
 */
export const useBankCardList = () => {
    return useSWR<PlaidBankCardItem[]>(
        {
            url: API.TRADE.funding.getCardList(),
            params: {
                customer_id: security.currentCustomerId,
                account_id: security.currentAccountId,
                supported_bank: true // 是否支持从bank-card-relation获取银行账户 兼容旧版逻辑
            }
        },
        {
            dataChain: resp => {
                return resp.data?.items?.filter(({ status, id_source }) => {
                    // 手动认证银行卡只展示可用的
                    if (id_source === 'Bank') {
                        return status === 'AVAILABLE';
                    }

                    // plaid 银行卡全部展示
                    return true;
                });
            }
        }
    );
};
